import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { RouteErrorDisplay } from '@/components/RouteErrorDisplay'

export const Route = createFileRoute('/app/dashboard')({
  component: lazyRouteComponent(() => import('./-dashboard')),
  errorComponent: ({ error }) => (
    <QueryErrorResetBoundary>
      {({ reset }) => <RouteErrorDisplay error={error} reset={reset} />}
    </QueryErrorResetBoundary>
  ),
})
